import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { productsJsmFeatureUsageRoute } from '@atlassian/jira-router-routes-products-jsm-feature-usage-routes/src/productsJsmFeatureUsageRoute.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import ProductsJsmFeatureUsage, { LazyProductsJsmFeatureUsage } from './ui/index.tsx';

export const productsJsmFeatureUsageRouteEntry = createEntry(productsJsmFeatureUsageRoute, () => ({
	group: 'global-settings',
	component: ProductsJsmFeatureUsage,
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
		menuId: MENU_ID.SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsProducts,
	},

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		workspaceResource,
	],

	forPaint: [LazyAtlassianNavigation, LazyProductsJsmFeatureUsage],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-products-jsm-feature-usage-entries/src/productsJsmFeatureUsageRouteEntry.tsx',
			whichExportToUse: 'productsJsmFeatureUsageRouteEntry',
		},

		enabled: true,
	},
}));
